import { UserCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  cellphone: {
    inputType: 'tel',
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  user_category_id: {
    'ui:widget': UserCategorySelectionWidget,
  },
});

export default uiSchema;
